import { Billing, CompanyContact } from './Client'

export class Supplier {
  constructor(supplierInfo) {
    if (!supplierInfo) {
      this.supplierId = null
      this.accountNumber = null
      this.accountManager = null
      this.registrationNumber = null
      this.name = null
      this.location = null
      this.addresses = null
      this.primaryContact = null
      this.secondaryContact = null
      this.billingContact = null
      this.billing = null
      this.services = null
      this.insurance = null
      this.contract = null
      this.status = null
      this.regionName = null
      this.supplierGroupId = null
    } else {
      this.supplierId = supplierInfo.id ? supplierInfo.id : null
      this.accountNumber = supplierInfo.accountNumber
        ? supplierInfo.accountNumber
        : null
      this.accountManager = supplierInfo.accountManager
        ? supplierInfo.accountManager
        : null
      this.registrationNumber = supplierInfo.registrationNumber
        ? supplierInfo.registrationNumber
        : null
      this.companyName = supplierInfo.companyName
        ? supplierInfo.companyName
        : null
      this.address = supplierInfo.addresses ? supplierInfo.addresses : null
      this.primaryContact = supplierInfo.primaryContact
        ? new CompanyContact(supplierInfo.primaryContact)
        : null
      this.secondaryContact = supplierInfo.secondaryContact
        ? new CompanyContact(supplierInfo.secondaryContact)
        : null
      this.billingContact = supplierInfo.billingContact
        ? new CompanyContact(supplierInfo.billingContact)
        : null
      this.contacts = supplierInfo.contacts ? supplierInfo.contacts : null
      this.billing = supplierInfo.billing
        ? new Billing(supplierInfo.billing)
        : null
      this.status = supplierInfo.status ? supplierInfo.status : null
      this.regionName = supplierInfo.regionName ? supplierInfo.regionName : null
      this.supplierGroupId = supplierInfo.supplierGroupId
        ? supplierInfo.supplierGroupId
        : null
    }
  }
  getObject() {
    return JSON.parse(JSON.stringify(this))
  }
}
